module.exports = __webpack_public_path__ + "static/media/eye.c0c4ac95.svg";